// src/pages/ReadabilityTools/tabs/WordLookupTab/index.js

import React from 'react';
import {
  Box,
  Typography,
  Alert,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useWordLookup } from './useWordLookup';
import WordDetails from './WordDetails';
import WordSearchInput from './WordSearchInput';


const WordLookupTab = () => {
  const theme = useTheme();
  const {
    searchWord,
    wordData,
    loading,
    error,
    handleWordChange,
    clearSearch,
    lookupWord,
    handleKeyPress,
    canLookup,
    hasResults
  } = useWordLookup();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Word Lookup
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Look up any word to see its Readable English translations, homographs, and homophones.
      </Typography>

      <WordSearchInput
        searchWord={searchWord}
        onChange={handleWordChange}
        onClear={clearSearch}
        onSearch={lookupWord}
        onKeyPress={handleKeyPress}
        loading={loading}
        canLookup={canLookup}
        placeholder="e.g. read, lead, bow"
      />

      {error && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 3, 
            bgcolor: alpha(theme.palette.error.main, 0.1),
            color: theme.palette.error.main
          }}
        >
          {error}
        </Alert>
      )}

      {hasResults && <WordDetails wordData={wordData} />}
    </Box>
  );
};

export default WordLookupTab;